var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Spacer',[_c('div',{staticClass:"spacer--padding--t--xxl"},[_c('div',{class:['iframe-div', {'youtube' : _vm.data.embed.includes('youtube')}],domProps:{"innerHTML":_vm._s(_vm.data.embed)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }